import React from 'react';
import {
  Upload,
} from 'antd';
import CloseHoverContainer from '../CloseHoverContainer/index';
import { UploadChangeParam, UploadFile } from 'antd/lib/upload/interface'
import { BaseComponentProps } from '../../../../interface'

export type Position = 'top' | 'bottom-left' | 'bottom-right'

interface Props extends BaseComponentProps {
  onRemove: (position: Position) => void,
  onDrop: (position: Position) => void,
  onChange?: ((info: UploadChangeParam<UploadFile<any>>, position: Position) => void) | undefined,
  position: Position,
  imgSrc?: string
}

const PreviewImageContainer: React.FC<Props> = ({
  style = {},
  position = 'top',
  className = undefined,
  onRemove = () => null,
  onDrop = () => null,
  onChange = () => null,
  imgSrc = ''
}) => {

  function handleDragOver(e: any) {
    e.stopPropagation()
    e.preventDefault()
  }

  return (
    <CloseHoverContainer
      showClose={!!imgSrc}
      onClose={() => onRemove(position)}
    >
      <div
        className={className}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        onDragOver={handleDragOver}
        onDragEnter={handleDragOver}
        onDrop={e => {
          e.stopPropagation()
          e.preventDefault()
          onDrop(position)
        }}
      >
          {
            imgSrc ? (
              <img 
                src={imgSrc}
                style={{
                  width: '100%',
                  height: '100%'
                }}
              />
            ) :
            (
              <Upload
                accept=",jpeg,jpg"
                beforeUpload={() => false}
                showUploadList={false}
                onChange={info => onChange(info, position)}
                style={{
                  cursor: 'pointer'
                }}
              >
                点击上传图片
              </Upload>
            )
          }
      </div>
    </CloseHoverContainer>
  )
}

export default PreviewImageContainer;